export const ADMIN_ROUTE_PATHS = {
  viewPermissions: '/admin/view-permissions',
  userRegistry: '/admin/user-registry',
  roleManagement: '/admin/role-management',
};
